import { useCallback, useSyncExternalStore } from "react";

/**
 * Subscribe to a CSS media query and re-render on match changes. Backed by
 * `useSyncExternalStore` so it stays correct across resizes without a manual
 * effect. Returns `false` when `matchMedia` is unavailable (non-browser / SSR).
 *
 * Example: `const isDesktop = useMediaQuery("(min-width: 881px)")`.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof matchMedia === "undefined") return () => {};
      const mql = matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    [query],
  );

  const getSnapshot = () => (typeof matchMedia !== "undefined" ? matchMedia(query).matches : false);

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
